import {
  capitalize
} from 'lodash';
import {
  Component
} from "react";
import Ui3DotsMenu from '../../dictionaries/Ui3DotsMenu.dic';
import {
  sanitizeArr
} from '../../lib/Array.lib';
import {
  NOT
} from '../../lib/Boolean.lib';
import openWindow from '../../lib/Browser/openWindow.async';
import fetchCandidateResume from '../../lib/Candidate/fetchCandidateResume.async';
import Core from '../../lib/Core';
import Definition, {
  DEFINITION_CATEGORY__TECHNICAL_SKILLS
} from "../../lib/Definition";
import fetchResumeHighlightsNonComplexTasksList from '../../lib/services/Configurations/fetchResumeHighlightsNonComplexTasksList.fun';
import {
  compileText
} from '../../lib/String.lib';
import {
  matchLocation
} from '../../lib/URL.lib';
import getTagIdsTechSkillsRelevant from '../Candidates/ResumePdf/Libraries/getTagIdsTechSkillsRelevant.fun';
import Menu from '../Layout/Wrappers/Menu';

class ResumeMatch extends Component {

  allTechnicalSkills = Definition.getLabels(
    DEFINITION_CATEGORY__TECHNICAL_SKILLS,
    getTagIdsTechSkillsRelevant()
  );

  processSkills = (skills, text, attributes = {}, specialCharacters = []) => {
    let regex = "";
    const specialSkills = ["c++", "C++", "c#", "C#", ".net", ".Net"];

    if (skills.length > 0 && text) {
      skills.filter(val => val && val.length)
        .forEach(val => {
          if (specialSkills.includes(val)) {
            // SPECIAL WORDS (handled literally)
            const escapedVal = this.escapeRegExp(val);
            const specialRegex = new RegExp(escapedVal, 'g');
            text = text.replace(
              specialRegex,
              `<span style="background-color: ${attributes.color};">$&</span>`
            );

          }
          else if (val.length === 1) {

            // SINGLE CHARACTER (like "R" or "C")
            const escapedVal = this.escapeRegExp(val);
            regex = new RegExp(`\\b${escapedVal}\\b`, 'gi');
            text = text.replace(
              regex,
              `<span style="background-color: ${attributes.color};">$&</span>`
            );

          }
          else {

            // GENERAL WORDS (like "angular", "react", etc.)
            const escapedVal = this.escapeRegExp(val);
            regex = new RegExp(`\\b${escapedVal}[\\w-]*\\b`, 'gi');
            text = text.replace(
              regex,
              `<span style="background-color: ${attributes.color};">$&</span>`
            );

          }
        });
    }

    return text;
  };


  escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  matchResume = () => {
    const { showOnDrawer, renderTextCV } = this.props;

    const { candidateResume, jobSkills, employerSkills } = this.props;

    const jobSkillsValue = typeof jobSkills === "string"
      ? jobSkills
        .split(',')
        .map(el => el.trim())
      : [];

    const employerSkillsValue = typeof employerSkills === "string"
      ? employerSkills
        .split(',')
        .map(el => el.trim())
        .filter(v => !jobSkillsValue.includes(v))
      : [];

    const allTechnicalSkills = sanitizeArr(
      this.allTechnicalSkills
    ).filter(
      (label) => ![...jobSkillsValue, ...employerSkillsValue].includes(label)
    );

    const specialCharacters = ['+', '#'];

    const green = '#00ff1155';
    const yellow = '#ffee0066';
    const red = '#ff000055';
    const blue = '#0000ff55';

    fetchCandidateResume({
      url: candidateResume,
      source: 'ResumeMatch__matchResume',
    }).then(async (text = '') => {
      text = this.processSkills(
        allTechnicalSkills, text, { color: green }, specialCharacters
      );
      text = this.processSkills(
        employerSkillsValue, text, { color: yellow }, specialCharacters
      );
      text = this.processSkills(
        jobSkillsValue, text, { color: red }, specialCharacters
      );

      if (NOT(Core.isEmployer())) {
        const nonComplexTasksList = await fetchResumeHighlightsNonComplexTasksList();
        text = this.processSkills(
          nonComplexTasksList, text, { color: blue }, specialCharacters
        );
      }

      text = text.replace(/\n/g, "<br />");
      if (this.props.onClick instanceof Function) {
        this.props.onClick(text);
      }
      else if (!showOnDrawer) {
        openWindow({
          title: getTitle(),
          content: text
        });
      }
      else {
        renderTextCV(text);
        this.fetched = true;
        this.fetching = false;
      }
    });
  }

  render() {
    const { element, showOnDrawer, onClick = (method = () => { }) => event => method(event) } = this.props;
    if (showOnDrawer && !this.fetching && !this.fetched) {
      this.fetching = true;
      this.matchResume();
    }
    return (
      !!element ? element(this.matchResume) : (
        <Menu.Item onClick={onClick(this.matchResume)} divider>
          {getTitle()}
        </Menu.Item>
      )
    );
  }
}

export default ResumeMatch;

function getTitle() {
  return capitalize(
    compileText(Ui3DotsMenu.Candidate.viewResumeText, {
      PREFIX: (
        matchLocation(/\/(candidates|create|edit)/i)
          ? ''
          : Ui3DotsMenu.Candidate.PREFIX
      ),
    })
  );
}
